var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8887 1.2584C14.2984 1.19696 14.6803 1.47922 14.7417 1.88885L15.0584 4.0001H20C21.1046 4.0001 22 4.89553 22 6.0001V16.0001C22 17.1047 21.1046 18.0001 20 18.0001H17.1584L17.7417 21.8888C17.8031 22.2985 17.5209 22.6804 17.1113 22.7418C16.7016 22.8032 16.3197 22.521 16.2583 22.1114L15.6416 18.0001H8.35839L7.7417 22.1114C7.68026 22.521 7.29838 22.8032 6.88874 22.7418C6.47911 22.6804 6.19685 22.2985 6.2583 21.8888L6.84161 18.0001H4C2.89543 18.0001 2 17.1047 2 16.0001V6.0001C2 4.89553 2.89543 4.0001 4 4.0001H8.94161L9.2583 1.88885C9.31974 1.47922 9.70162 1.19696 10.1113 1.2584C10.5209 1.31984 10.8031 1.70173 10.7417 2.11136L10.4584 4.0001H13.5416L13.2583 2.11136C13.1969 1.70173 13.4791 1.31984 13.8887 1.2584Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteboard);
export default __webpack_public_path__ + "static/media/whiteboard.02e1583d4a526b9b8d25d4ce582b90aa.svg";
export { ForwardRef as ReactComponent };